import axios from 'axios';

export const getBasicHeaders = () => {
    return {
        'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_SUBSCRIPTION,
        'Content-Type': 'application/json',
        Accept: 'application/json',
    };
};

export const getHeadersWithFormData = () => {
    return {
        'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_SUBSCRIPTION,
        "Content-Type": "multipart/form-data",
        Accept: 'application/json',
    };
};

export const getSpeakerBasicHeaders = () => {
    return {
        'Ocp-Apim-Subscription-Key': process.env.VUE_APP_SPEAKER_API_SUBSCRIPTION,
        'Content-Type': 'application/json',
        Accept: 'application/json',
    };
};

export const getRandomId = () => {
    return Math.floor(Math.random() * Math.floor(Date.now())).toString();
};

export const removeSpaces = (str) => {
    if (str) {
        return str.replace(/[()\s.-]/g, '');
    }
};

export const jsonClone = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};

export const imageErrorFallback = (url) => {
    return `this.src='${url || ''}';this.onerror=null;`;
};

export const imageWithTimeStamp = (url) => {
    return url ? `${url}?t${new Date().getTime()}` : '';
};

export const numberCommaSeparated = (number) => {
    if (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
};
export const getHeadersForForum = (token) => {
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
    };
};
export const normalizeUrl = (url) => {
    if (/^https?:\/\//i.test(url)) return url;
    return `http://${url}`;
};

export const openHtmlLink = (url, isMobileAppBrowser) => {
    if (url) {
        if (url.startsWith("mailto:")) {
            window.location.href = url;
        } else {
            const appOrigin = window.location.origin;
            if (!url.includes('http')) {
                url = `https://${url}`;
            }
            if (url.includes(appOrigin) || isMobileAppBrowser) {
                    window.open(url, "_self");
            } else {
                    window.open(url, "_blank");
            }
        }
    }
  };


export const validateUrl = (url) => {
    return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9A-Z]+([-.]{1}[a-z0-9A-Z]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(url);
};

export const validateEmail = (email) => {
    const expression = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
    return expression.test(email);
};

export const onlyNumber = ($event) => {
    const keyCode = $event.keyCode ? $event.keyCode : $event.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 8) {
        $event.preventDefault();
    }
};
export const zipPostalCodeValidation = ($event) => {
    if ($event.charCode === 0) {
        return true;
    }
    // Allow Hiphen (-)
    if ($event.charCode === 45) {
        return true;
    }
    // Allow Alphanumerics
    if ($event.charCode >= 48 && $event.charCode <= 57) {
        return true;
    }
    if ($event.charCode >= 65 && $event.charCode <= 90) {
        return true;
    }
    if ($event.charCode >= 97 && $event.charCode <= 122) {
        return true;
    }
    $event.preventDefault();
};
export const capitalizedString = (str) => {
    return (
        str
            .toLowerCase()
            .charAt(0)
            .toUpperCase() + str.slice(1)
    );
};
export const fetchAndCacheData = (request, commit, mutation, cache, url) => {
    return axios(request)
        .then((res) => {
            commit(mutation, res.data);
            cache.put(url, new Response(JSON.stringify({ requestedTime: Date.now(), data: res.data })));
            return res;
        })
        .catch((err) => {
            commit(mutation, []);
            cache.put(url, new Response(JSON.stringify({})));
            console.log(err);
            throw err;
        });
};

export const getPxToRemVal = (px) => {
    let result = 0;
    if (px >= 0) {
        result = `${px / 15}rem`;
    }
    return result;
};
export const textCountLimiter = ($event, text, maxCount) => {
    if (text) {
        const textCount = text.length;
        if (textCount >= maxCount) {
            $event.preventDefault();
            return true;
        }
    }
};

export const arrayMoveIndex = (arr, fromIndex, toIndex) => {
    const elm = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, elm);
    return arr;
};
export const priceToDisplay = ($event, price, maxCount) => {
    const keyCode = $event.keyCode ? $event.keyCode : $event.which;
    if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || price.indexOf('.') !== -1)) {
        $event.preventDefault();
    }
    if (price !== null && price.indexOf('.') > -1 && price.split('.')[1].length > 1) {
        $event.preventDefault();
    }
    if (price) {
        const textCount = price.length;
        if (textCount >= maxCount) {
            $event.preventDefault();
            return true;
        }
    }
};

export const getCommaSeparatedValue = (number) => {
    if (number) {
        number = number.replace(/,/g, '');
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
};

export const removeCommas = (number) => {
    if (number) {
        return number.replace(/,/g, '');
    }
};

// Replace all HTML and Ck Editor Special characters from given string
export const removeHTMLAndSpecialCharacters = (stringData) => {
    if (stringData) {
        return stringData.replace(/&nbsp;/g, " ")
            .replace(/\n/g, ' ')
            .replace(/<\/*.*?>/g, '')
            .replace(/&quot;/g, "\"")
            .replace(/&ndash;/g, "–")
            .replace(/&gt;/g, '>')
            .replace(/&lt;/g, '<')
            .replace(/&amp;/g, '&');
    }
};

export const getMaskedEmail = (email) => {
    let result = "";
    if (email && validateEmail(email)) {
        const emailParts = email.split("@");
        const emailFirstParts = emailParts[0].split("");
        if (emailFirstParts.length > 2) {
            emailParts[0] = `${emailFirstParts[0]}...${emailFirstParts[emailFirstParts.length - 1]}`;
        }
        result = emailParts.join("@");
    }
    return result;
};

export const splitAndConcatFromCapitalString = (text) => {
    let result = "";
    if (text && text.length) {
        const brokenList = text.split(/(?=[A-Z])/);
        result = brokenList.join(' ');
    }
  return result;
};

export const removeLastChar = (str) => {
    return str.slice(0, -1);
};

export const removeFirstCharacter = (str) => {
    return str.replace(/^0+/, '');
};

